import { baseWebUrl, sweetAlert, AlertType, baseAPIUrl, httpPostHandleResponse, isNullOrEmpty, initializeJqueryValidator, AlertTitle } from "../../utils/common";
import http from "../../services/httpService";
import { Loader } from "../../services/loaderService";

class Contants {
    readonly controller: string = baseAPIUrl() ? `${baseAPIUrl()}/Authentication` : '/Authentication';
    readonly webUrl: string = baseWebUrl();
    readonly $btnLogin: string = '#kt_Login_Signin_Submit';
    readonly $userName: string = '#txtuserName';
    readonly $password: string = '#txtpassword';
    readonly $kt_email: string = '#kt_email';
    readonly $kt_username: string = '#kt_username';
    readonly $btnForgot: string = '#kt_login_forgot_submit';

}

class Login {
    constants: Contants = new Contants();
    loader: Loader = new Loader();
    localStorageCart: any;
    responseDataObj: any;

    $btnLogin: JQuery<HTMLElement>;
    $userName: JQuery<HTMLElement>;
    $password: JQuery<HTMLElement>;

    $btnForgot: JQuery<HTMLElement>;
    $kt_email: JQuery<HTMLElement>;
    $kt_username: JQuery<HTMLElement>;

    constructor() {
        this.Init();
    }

    private Init = async () => {

        localStorage.setItem('LastSelectedMenu', '');

        window.history.forward();

        const rules = {
            txtuserName: {
                required: true,
                onlySpacesNotAllowed: true
            },
            txtpassword: {
                required: true,
                onlySpacesNotAllowed: true
            }
        };

        initializeJqueryValidator("#axon_form", rules);
        this.BindEvent();
    }

    private BindEvent = async () => {

        this.$userName = $(this.constants.$userName);
        this.$password = $(this.constants.$password);
        this.$btnLogin = $(this.constants.$btnLogin);

        this.$kt_username = $(this.constants.$kt_username);
        this.$kt_email = $(this.constants.$kt_email);
        this.$btnForgot = $(this.constants.$btnForgot);

        this.$btnLogin.on('click', this.onLoginButtonClick);
        this.$btnForgot.on('click', this.onForgotButtonClick);

        $(document).on('keypress', (e)=> {
            if (e.which == 13) {
                this.$btnLogin.trigger('click');
            }
        });
    }

    private onForgotButtonClick = async () => {
        this.loader.showLoader();

        const email = {
            Email: this.$kt_email.val(),
            UserName: this.$kt_username.val()
        };

        if (isNullOrEmpty(email.Email)) {
            sweetAlert(AlertType.Error, AlertTitle.Error, "Email address Required.");
            this.loader.hideLoader();
            return;
        };

        if (isNullOrEmpty(email.UserName)) {
            sweetAlert(AlertType.Error, AlertTitle.Error, "Username Required.");
            this.loader.hideLoader();
            return;
        };

        const response = await http.post(this.constants.controller + "/ForgotPassword", email);
        const data = httpPostHandleResponse(response);

        this.loader.hideLoader();
    }

    private onLoginButtonClick = async () => {
        if ($("#axon_form").valid()) {
            this.loader.showLoader();

            const user = {
                UserName: this.$userName.val().toString().toLowerCase(),
                Password: this.$password.val(),
                UserRole: "",
                FullName: ""

            };

            const response = await http.post(this.constants.controller + "/Authenticate", user);
            const data = httpPostHandleResponse(response);
            if (data && !isNullOrEmpty(data.Token)) {

                localStorage.setItem("SecurityToken", data.Token);
                localStorage.setItem("SetupTime", new Date().getTime().toString());
                localStorage.setItem("UserData", JSON.stringify(data.User));
                localStorage.setItem("Configuration", JSON.stringify(data.ConfigurationObj));
                localStorage.setItem("Menu", JSON.stringify(data.MenuObj));
                localStorage.setItem("RedirectionURL", "AU");
                this.loader.hideLoader();
                window.location.href = this.constants.webUrl + "/Admin/Dashboard/";
            }
            else {
                sweetAlert(AlertType.Error,"Invalid","Invalid username and password.")
            }
            this.loader.hideLoader();
        }
       
    }
}

$(() => new Login());